module.exports = __webpack_public_path__ + "pc/img/img_award2023_05.79aee18a.png";